import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

// Define the state interface for the Guest RFQ Form
export interface GuestRFQFormState {
	isLoading: boolean;
}

// Initialize the default state for the Guest RFQ form
const initialState: GuestRFQFormState = {
	isLoading: false,
};

// Define the reducer object with action handlers for the Guest RFQ form
const GuestRFQFormReducer = {
	"Custom/GuestRFQ/BeginApiCallService": (draft: Draft<GuestRFQFormState>) => {
		draft.isLoading = true;
	},
	"Custom/GuestRFQ/CompleteLoadApiCallService": (
		draft: Draft<GuestRFQFormState>,

	) => {
		draft.isLoading = false;
	},
};

// Create the reducer using the initial state and the defined reducer actions
export default createTypedReducerWithImmer(initialState, GuestRFQFormReducer);

{/* EC-235 = Reducer to handle the Guest RFQ form Submission State */}
